export const mayUppercase = "gra";
export default {mayUppercase};